/** The URL keys a table's filters use, in a module with no imports so `screens/search.ts` can name them
 * without pulling the router into the URL contract. A filter `site` is `f_site`; the table's own
 * search is `fq`. They are screen-owned: see `searchForScreen` in `search.ts`. */

export const FILTER_PREFIX = "f_";
export const SEARCH_KEY = "fq";

export function isTableKey(key: string): boolean {
  return (key.startsWith(FILTER_PREFIX) && key.length > FILTER_PREFIX.length) || key === SEARCH_KEY;
}
